import { globalStore } from './modules/global.store'
import { authStore } from './modules/auth.store'
import { routeStore } from './modules/route.store'
import { mapStore } from './modules/map.store'
import { liveStore } from './modules/live.store'
import { modalStore } from './modules/modal.store'
import { userStore } from './modules/user.store'
import { uiStore } from './modules/ui.store'
import { devStore } from './modules/dev.store'

export const store = {
  user: userStore,
  global: globalStore,
  auth: authStore,
  map: mapStore,
  route: routeStore,
  live: liveStore,
  modal: modalStore,
  ui: uiStore,
  dev: devStore
}

export function initializeStore() {
  store.global.initialize()
}